import React, { useCallback } from 'react';
import Text from 'design-system/Text';
import { muteAll, useFetchOld } from 'hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { useAppSelector } from 'store/hooks';
import { PauseAutoinvestExpiryDateType } from '../types';
import { formatPauseAutoinvestDate } from '../utils';
import { pauseAndOptionallySkip } from '../utils/pauseAutoinvest';
import { selectLatestAutoinvestActivity } from '../reducers/selectors';
const fetchOptions = {
    ...muteAll,
    throws: true,
    muteFetching: false,
};
const usePauseAndOptionallySkipAutoinvest = ({ planId, skipUpcoming, expectedPaymentDate, activityId, popCount, }) => {
    const navigation = useMainStackNavigation();
    const [, , fetching, fetch] = useFetchOld(fetchOptions);
    const latestActivity = useAppSelector(selectLatestAutoinvestActivity);
    const handleSave = useCallback(async (pauseSelection) => {
        if (!pauseSelection?.finalDate)
            return;
        const pausedUntil = pauseSelection.type === PauseAutoinvestExpiryDateType.NO_LIMIT
            ? undefined
            : pauseSelection.finalDate.toISOString();
        const latestActivityStatus = latestActivity?.status;
        const { success } = await pauseAndOptionallySkip(planId, pausedUntil, !!skipUpcoming, expectedPaymentDate, activityId, fetch);
        if (!success)
            return;
        const title1 = (() => {
            if (pauseSelection.type === PauseAutoinvestExpiryDateType.NO_LIMIT) {
                return `Your Autoinvest is paused. Collections will start again if you turn the feature back on.${skipUpcoming ? '\n\nYour upcoming payment has been skipped.' : ''}`;
            }
            return (<Text TextThin-16 Secondary>
            Your Autoinvest is on hold until{' '}
            <Text Text-16 Secondary>
              {formatPauseAutoinvestDate(pauseSelection.finalDate)}
            </Text>
            . I{'\u2019'}ll notify you when I start investing again.
            {skipUpcoming ? '\n\nYour upcoming payment has been skipped.' : ''}
          </Text>);
        })();
        const title2 = (() => {
            if (!skipUpcoming && latestActivityStatus === 'upcoming') {
                return '\n\nYour upcoming payment will be processed unless skipped.';
            }
            if (latestActivityStatus === 'pending') {
                return '\n\nYour pending payment will be processed as usual.';
            }
            return '';
        })();
        navigation.navigate('Success', {
            title: 'Success',
            subTitle: (<Text TextThin-16 Secondary>
            {title1}
            {title2}
          </Text>),
            onContinue: () => {
                navigation.pop(popCount);
                return true;
            },
            buttonText: 'Got it',
        });
    }, [latestActivity?.status, planId, skipUpcoming, expectedPaymentDate, activityId]);
    return { handleSave, fetching };
};
export default usePauseAndOptionallySkipAutoinvest;
